// extracted by mini-css-extract-plugin
var _1 = "DecoratorSettings_placeholderField__e5946";
var _2 = "DecoratorSettings_placeholderInput__82e00";
var _3 = "DecoratorSettings_root__47953";
export { _1 as "placeholderField", _2 as "placeholderInput", _3 as "root" }
